import { Outlet, useMatches } from "react-router-dom";

/** Route `handle` flag: the page opts out of the centered `container` width cap. */
export interface SettingsRouteHandle {
  fullWidth?: boolean;
}

export default function SettingsLayout() {
  const fullWidth = useMatches().some(
    (match) => (match.handle as SettingsRouteHandle | undefined)?.fullWidth,
  );
  return (
    <div className={fullWidth ? "h-full w-full" : "container h-full"}>
      <Outlet />
    </div>
  );
}
